import { CommonSettings } from '@starsoft/common/interfaces';
import { useSettingsStore } from '../useSettingsStore';
import { UseTranslationReturn } from '@starsoft/common/interfaces/translation-return';

/**
 * Custom hook to provide translation functionalities.
 * This hook uses the settings store to get the translation functions and current language.
 *
 * @param {string} [namespace] - Optional namespace for the translations.
 * @returns {Object} An object containing the translation function `t`, the i18n instance, and the current language.
 *
 * @example
 * // Usage example:
 * const { t, i18n, lang } = useTranslation('common');
 */
export function useTranslation(namespace?: string) {
  // Get the state from the settings store
  const { state } = useSettingsStore();
  // Get the settings from the state
  const settings: CommonSettings = state.settings;
  // Get the translation function, i18n instance, and current language from the settings
  const { t, i18n, lang }: UseTranslationReturn =
    settings.useTranslation(namespace);
  // Return the translation function, i18n instance, and current language
  return {
    t,
    i18n,
    lang: lang ?? i18n?.language,
  };
}
